import header from "./close-up-hand-drawing-house-plan_smaller-size.jpg";
import section1 from "./zeichnen-auf-grafiktablet.jpg";
import section2 from "./modernes-flachdachhaus.webp";
import section3 from "./grundriss laptop.png";
import section4 from "./haus-mit-balkon.webp";

export { header, section1, section2, section3, section4 };
